module.exports = __webpack_public_path__ + "media/images/default/homepage/about/Icn-56-1-cc7fab3c4d722ce85cbb6ba6931219c2.svg";